import { useCssVars as _useCssVars, unref as _unref } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sky" }
const _hoisted_2 = { class: "star-cloud-box" }
const _hoisted_3 = { class: "cloud-box" }
const _hoisted_4 = { class: "halo-box" }
const _hoisted_5 = {
  key: 0,
  class: "halo-linear"
}
const _hoisted_6 = {
  key: 1,
  class: "halo-flex"
}
const _hoisted_7 = { class: "ball-box" }

import { ref, reactive, computed, onMounted } from "vue";



import { watch } from 'vue';
export default {
  __name: 'DarkThemeModeSelector',
  props: {
  size: {
    type: [String, Number],
    default: "100px",
    // 按钮高度, 示例: '20', '20px'
  },
  ball: {
    type: String,
    default: "cut-in",
    // cut-in: 月球切入出现, gradient: 月球渐变出现
  },
  halo: {
    type: String,
    default: "flex",
    // flex: 光晕弹性运动, linear: 光晕线性运动
  },
  initial: {
    type: [Boolean],
    default: false,
    // 开关初始状态（布尔：true黑夜、false白天）
  },
  finish: {
    type: String,
    default: "now",
    // now: 鼠标移出后的月亮瞬间回到原位, delay: 鼠标移出后的月亮转至终点
  },
},
  emits: ["onStatus"],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "38cf6fcd": (parsedSize.value)
}))

const emit = __emit;

const props = __props;

const parsedSize = computed(() => {
  if (typeof props.size[(-2, -1)] !== "px") {
    return `${props.size}px`;
  }
  return props.size;
});

const ballStatus = ref(props.initial);
watch(
  () => props.initial,
  (newValue) => {
    // 持续监听主题状态并在出现改变时触发动画
    if (newValue !== ballStatus.value) ballTrans();
  }
);
const ballTrans = () => {
  if (ballStatus.value) {
    ballStatus.value = false;
    emit("onStatus", ballStatus.value);
    dayHoverAnimation();
    nightHoverAnimationReset();
  } else if (!ballStatus.value) {
    ballStatus.value = true;
    emit("onStatus", ballStatus.value);
    nightHoverAnimation();
    dayHoverAnimationReset();
  }
};

// 云朵摆动状态
const shakeStatus = ref(false);
// 云朵摆动延迟
const dayHoverAnimationDelayId = ref(null);
// 云朵停止重复计时器
const shakeIntervalId = ref(null);
const dayHoverAnimation = () => {
  if (!ballStatus.value && !shakeStatus.value) {
    if (!ballStatus.value) {
      shakeStatus.value = true;
      shakeIntervalId.value = setInterval(() => {
        if (ballStatus.value) {
          shakeStatus.value = false;
          clearInterval(shakeIntervalId.value);
        }
      }, 4000);
    }
  }
};
const dayHoverAnimationReset = () => {
  clearTimeout(dayHoverAnimationDelayId.value);
  dayHoverAnimationDelayId.value = null;
};

const cloudNearList = [
  { size: 1.2, top: "15%", right: "-13%" },
  { size: 1.3, top: "39%", right: "-5%" },
  { size: 1.0, top: "66%", right: "5%" },
  { size: 1.5, top: "80%", right: "26%" },
  { size: 1.2, top: "75%", right: "38%" },
  { size: 1.3, top: "83%", right: "55%" },
  { size: 1.3, top: "89%", right: "68%" },
];

const cloudFarList = [
  { size: 1.2, top: "2%", right: "-5%" },
  { size: 1.4, top: "25%", right: "5%" },
  { size: 1.0, top: "37%", right: "10%" },
  { size: 1.5, top: "58%", right: "30%" },
  { size: 1.2, top: "55%", right: "38%" },
  { size: 1.3, top: "70%", right: "57%" },
  { size: 1.1, top: "77%", right: "66%" },
];

const getCloudNearStyle = (cloud) => {
  return {
    height: `calc(var(--near-cloud-size) / ${cloud.size})`,
    width: `calc(var(--near-cloud-size) / ${cloud.size})`,
    top: cloud.top,
    right: cloud.right,
  };
};

const getCloudFarStyle = (cloud) => {
  return {
    height: `calc(var(--far-cloud-size) / ${cloud.size})`,
    width: `calc(var(--far-cloud-size) / ${cloud.size})`,
    top: cloud.top,
    right: cloud.right,
  };
};

const craterList = [
  { id: 1, size: 0.18, top: "15%", left: "38%" },
  { id: 2, size: 0.32, top: "46%", left: "13%" },
  { id: 3, size: 0.22, top: "61%", left: "61%" },
];

// 配置星星大小位置
const starList = [
  { id: 0, size: 1.5, top: "13%", left: "20%" },
  { id: 1, size: 0.5, top: "28%", left: "10%" },
  { id: 2, size: 0.7, top: "43%", left: "22%" },
  { id: 3, size: 0.3, top: "68%", left: "15%" },
  { id: 4, size: 0.2, top: "75%", left: "11%" },
  { id: 5, size: 0.4, top: "78%", left: "22%" },
  { id: 6, size: 1.3, top: "21%", left: "53%" },
  { id: 7, size: 0.4, top: "20%", left: "42%" },
  { id: 8, size: 0.4, top: "48%", left: "37%" },
  { id: 9, size: 0.6, top: "53%", left: "52%" },
  { id: 10, size: 0.8, top: "73%", left: "46%" },
];

/**
 * 配置星星闪烁列表
 * @type {Array<Object>}
 * @property {number} twinkleId - 闪烁星星id
 * @property {null|number} twinkleInterval - 闪烁计时重复执行器
 * @property {boolean} twinkleShowStatus - 闪烁状态
 * @property {number} twinkleTime - 闪烁时间
 */
const twinkleList = reactive([
  {
    twinkleId: 1,
    twinkleInterval: null,
    twinkleShowStatus: false,
    twinkleTime: 1100,
  },
  {
    twinkleId: 3,
    twinkleInterval: null,
    twinkleShowStatus: false,
    twinkleTime: 1300,
  },
]);

// 防止nightHoverAnimation函数重复触发
const nightHoverAnimationStatus = ref(false);
// 夜晚动画延迟计时器
const nightHoverAnimationDelayId = ref(null);
const nightHoverAnimation = () => {
  // 函数处于非触发状态、闪烁计时器不存在、按钮处于夜晚状态，执行下一步
  if (
    !nightHoverAnimationStatus.value &&
    !nightHoverAnimationDelayId.value &&
    ballStatus.value
  ) {
    // 添加计时器
    // nightHoverAnimationDelayId.value = setInterval(() => {
    // 鼠标仍悬浮、按钮仍处于夜晚状态，执行下一步
    if (ballStatus.value) {
      // 函数改为触发状态
      nightHoverAnimationStatus.value = true;
      moonRotate();
      starTwinkle();
      meteorFall();
    } else {
      nightHoverAnimationReset();
    }
    // }, 2000);
  }
};

const starTwinkle = () => {
  twinkleList.forEach((twinkStar) => {
    twinkStar.twinkleShowStatus = true;
    if (!twinkStar.twinkleInterval) {
      twinkStar.twinkleInterval = setInterval(() => {
        twinkStar.twinkleId = (twinkStar.twinkleId + 3) % 11;
        if (!ballStatus.value) {
          clearInterval(twinkStar.twinkleInterval);
          twinkStar.twinkleInterval = null;
          twinkStar.twinkleShowStatus = false;
        }
      }, twinkStar.twinkleTime);
    }
  });
};

/**
 * 寻找闪烁的星星
 */
const ifTwinkle = (id) => {
  return twinkleList.some(
    (twinkleStar) =>
      twinkleStar.twinkleShowStatus && id === twinkleStar.twinkleId
  );
};

/**
 * 重置闪烁状态
 */
const nightHoverAnimationReset = () => {
  clearTimeout(nightHoverAnimationDelayId.value);
  nightHoverAnimationDelayId.value = null;
  nightHoverAnimationStatus.value = false;
  if (props.finish === "now") {
    rotateStatus.value = false;
  }
};

// 控制旋转动画
const rotateStatus = ref(false);
// 旋转计时重复执行器
const rotateInterval = ref(null);
const moonRotate = () => {
  rotateStatus.value = true;
  if (!rotateInterval.value) {
    rotateInterval.value = setInterval(() => {
      if (!ballStatus.value) {
        rotateStatus.value = false;
        clearInterval(rotateInterval.value);
        rotateInterval.value = null;
      }
    }, 12000);
  }
};

const meteorFallStatus = ref(false);
const meteorFallInterval = ref(null);
const meteorFall = () => {
  meteorFallStatus.value = true;
  if (!meteorFallInterval.value) {
    meteorFallInterval.value = setInterval(() => {
      if (!ballStatus.value) {
        meteorFallStatus.value = false;
        clearInterval(meteorFallInterval.value);
        meteorFallInterval.value = null;
      }
    }, 6000);
  }
};

// 挂载后开始激活动画
onMounted(() => {
  if (!ballStatus.value) {
    dayHoverAnimation();
    nightHoverAnimationReset();
  } else if (ballStatus.value) {
    nightHoverAnimation();
    dayHoverAnimationReset();
  }
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "button-box",
    onClick: ballTrans
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "inner-shadow" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass([ballStatus.value ? 'night' : 'day'])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["star-box", { 'star-move': !ballStatus.value }])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(starList, (star) => {
          return _createElementVNode("div", {
            key: star.id,
            class: _normalizeClass(["star", { twinkle: ifTwinkle(star.id) }]),
            style: _normalizeStyle({
            height: `calc(var(--star-size) * ${star.size})`,
            width: `calc(var(--star-size) * ${star.size})`,
            top: star.top,
            left: star.left,
          })
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              width: "100%",
              height: "100%",
              viewBox: "0 0 100 100"
            }, [
              _createElementVNode("path", {
                d: "M50,0 \n                            C62.5,37.5 62.5,37.5 100,50 \n                            C62.5,62.5 62.5,62.5 50,100 \n                            C37.5,62.5 37.5,62.5 0,50 \n                            C37.5,37.5 37.5,37.5 50,0",
                fill: "white"
              })
            ], -1)
          ]), 6)
        }), 64)),
        _createElementVNode("div", {
          class: _normalizeClass(["meteor", { 'meteor-fall': meteorFallStatus.value }])
        }, null, 2)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["cloud-near", { 'cloud-far-move': ballStatus.value }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cloudNearList, (cloud, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["cloud", { 'cloud-near-shake': shakeStatus.value }]),
              style: _normalizeStyle(getCloudNearStyle(cloud))
            }, null, 6)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["cloud-far", { 'cloud-far-move': ballStatus.value }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cloudFarList, (cloud, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["cloud", { 'cloud-far-shake': shakeStatus.value }]),
              style: _normalizeStyle(getCloudFarStyle(cloud))
            }, null, 6)
          }), 64))
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.halo === 'linear')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["halo-middle", { 'halo-left': !ballStatus.value, 'halo-right': ballStatus.value }])
            }, null, 2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["halo-inner", { 'halo-left': !ballStatus.value, 'halo-right': ballStatus.value }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["halo-middle", { 'halo-left': !ballStatus.value, 'halo-right': ballStatus.value }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["halo-outer", { 'halo-left': !ballStatus.value, 'halo-right': ballStatus.value }])
            }, null, 2)
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.ball === 'gradient')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ball-gradient", { 'to-left': !ballStatus.value, 'to-right': ballStatus.value }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["sun", { ballHide: ballStatus.value }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["moon", { ballHide: !ballStatus.value }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["moon-body", { 'moon-rotate': rotateStatus.value }])
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(craterList, (crater) => {
                  return _createElementVNode("div", {
                    key: crater.id,
                    class: _normalizeClass(`moon-crater`),
                    style: _normalizeStyle({
                height: `calc(var(--ball-size) * ${crater.size})`,
                width: `calc(var(--ball-size) * ${crater.size})`,
                top: crater.top,
                left: crater.left,
              })
                  }, null, 4)
                }), 64))
              ], 2),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "moon-shadow" }, null, -1))
            ], 2)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["ball-cut-in", { 'to-left': !ballStatus.value, 'to-right': ballStatus.value }])
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sun" }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["moon", { 'moon-cut-in': ballStatus.value }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["moon-body", { 'moon-rotate': rotateStatus.value }])
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(craterList, (crater) => {
                  return _createElementVNode("div", {
                    key: crater.id,
                    class: _normalizeClass(`moon-crater`),
                    style: _normalizeStyle({
                height: `calc(var(--ball-size) * ${crater.size})`,
                width: `calc(var(--ball-size) * ${crater.size})`,
                top: crater.top,
                left: crater.left,
              })
                  }, null, 4)
                }), 64))
              ], 2),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "moon-shadow" }, null, -1))
            ], 2)
          ], 2))
    ])
  ]))
}
}

}